import { Badge } from "@/components/ui/badge";
import { SentimentType } from "@/types/document";

interface RemarkEditorProps {
  selectedCriteriaId: string | null;
  sentiment: SentimentType | null;
  onSentimentChange: (sentiment: SentimentType) => void;
  actions?: React.ReactNode;
}

export const NoteEditorHeader = ({
  selectedCriteriaId,
  sentiment,
  onSentimentChange,
  actions,
}: RemarkEditorProps) => {
  return (
    <div className="flex gap-2 items-center">
      {!selectedCriteriaId && <Badge variant="secondary">Comment</Badge>}
      {selectedCriteriaId && <Badge>Remark</Badge>}

      {selectedCriteriaId && (
        <div className="flex items-center">
          <div className="border-l border-gray-300 pl-2 h-full mx-2" />
          <div className="flex items-center gap-4">
            <Badge
              variant="secondary"
              className={`cursor-pointer ${
                sentiment === "positive"
                  ? "bg-positive text-positive border-positive"
                  : "bg-white border-zinc-200 text-zinc-400"
              }`}
              onClick={() => onSentimentChange("positive")}
            >
              #strength
            </Badge>
            <Badge
              variant="secondary"
              className={`cursor-pointer ${
                sentiment === "negative"
                  ? "bg-negative text-negative border-negative"
                  : "bg-white border-zinc-200 text-zinc-400"
              }`}
              onClick={() => onSentimentChange("negative")}
            >
              #weakness
            </Badge>
          </div>
        </div>
      )}

      {actions && <div className="ml-auto">{actions}</div>}
    </div>
  );
};
